// extracted by mini-css-extract-plugin
export var heading = "CoverageLandingImageText-module--heading--4e6c9";
export var image = "CoverageLandingImageText-module--image--932da";
export var listItem = "CoverageLandingImageText-module--listItem--71559";
export var ol = "CoverageLandingImageText-module--ol--658b4";
export var paragraph = "CoverageLandingImageText-module--paragraph--70997";
export var reverseOrder = "CoverageLandingImageText-module--reverseOrder--574b1";
export var text = "CoverageLandingImageText-module--text--c86eb";
export var ul = "CoverageLandingImageText-module--ul--63d36";
export var wrapper = "CoverageLandingImageText-module--wrapper--c3b40";